import { render, staticRenderFns } from "./WindowSensorPanel.vue?vue&type=template&id=13443a8c&scoped=true&lang=pug&"
import script from "./WindowSensorPanel.vue?vue&type=script&lang=ts&"
export * from "./WindowSensorPanel.vue?vue&type=script&lang=ts&"
import style0 from "./WindowSensorPanel.vue?vue&type=style&index=0&id=13443a8c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13443a8c",
  null
  
)

export default component.exports